import { api, get } from '@/lib/api';

const BASE = '/notifications';

export interface UserNotification {
  id: string;
  kind: string;
  title: string;
  body: string;
  linkPath: string | null;
  readAt: string | null;
  createdAt: string;
}

export interface ListaDeNotificacoes {
  items: UserNotification[];
  unreadCount: number;
}

export const listarNotificacoes = () => get<ListaDeNotificacoes>(BASE);

export const marcarLida = (id: string) =>
  api<void>(`${BASE}/${id}/read`, { method: 'PATCH' });

export const marcarTodasLidas = () =>
  api<void>(`${BASE}/read-all`, { method: 'PATCH' });
